import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { earlyMsalInit } from './services/calendarService';

// MSAL popup afhandeling — moet zo vroeg mogelijk draaien.
// Als de app laadt in een popup-venster (na Microsoft login),
// herkent MSAL de response en sluit het popup-venster automatisch.
earlyMsalInit().catch(e => console.warn('MSAL early init:', e));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);